import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator';
import GoModal from '@/core/go-modal/go-modal.vue';
import { ChannelDatasourceProps } from '@/shared/modal/collection-channel/channel-mode-modal/channel-datasource-field/channel-datasource-field.component';
import ChannelDatasourceField from '@/shared/modal/collection-channel/channel-mode-modal/channel-datasource-field/channel-datasource-field.vue';
import { isEmptyArray } from '@/util/array-util';

@Component({
  components: {
    'channel-datasource-field': ChannelDatasourceField,
    'go-modal': GoModal,
  },
})
export default class ChannelModeModal extends Vue {
  @Model('open', { type: Boolean, required: true }) open!: boolean;
  @Prop({ type: Array, default: [] }) readonly datasource: ChannelDatasourceProps[];
  @Prop({ type: String }) readonly channelType: string;
  @Prop({ type: Boolean }) readonly showBackBtn: boolean;
  @Prop({ type: String }) readonly channelName: string;
  @Prop({ type: String }) readonly channelImageUri: string;
  isValid = true;

  @Emit('modal:close') close() {}

  @Emit('modal:back') back() {}

  @Emit('modal:ok') ok(payload: any) {}

  @Watch('open')
  onOpen() {
    if (this.open) {
      this.isValid = true;
    }
  }

  validateForm() {
    this.isValid = this.datasource.some(channelDatasource => {
      if (typeof channelDatasource.value === 'boolean') {
        return channelDatasource.value;
      }
      if (channelDatasource.value instanceof Array) {
        return !isEmptyArray(channelDatasource.value) && channelDatasource.value.every(value => value.trim());
      }
      return false;
    });
  }
}
